<li class="wpee-feed-list">
  <form [formGroup]="postForm" (ngSubmit)="onSubmit()">
    <div class="feed-header d-flex align-center upload_post">
      <div class="feed-profile-img">
        <a>
          <img [src]="profilePic" alt="Profile Picture">
        </a>
        <div class="feed-title-wrap">
          <mat-form-field appearance="fill" class="form-field">
            <textarea matInput placeholder="{{ 'What\'s new, ' + userName }}?" formControlName="postContent">
              </textarea>
            <mat-error
              *ngIf="postForm.controls['postContent'].hasError('required') && postForm.controls['postContent'].touched">
              Post content is required.
            </mat-error>
            <mat-error
              *ngIf="postForm.controls['postContent'].hasError('maxlength') && postForm.controls['postContent'].touched">
              Post content cannot exceed 200 characters.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="sub_btn">
        <button mat-raised-button color="primary" type="submit">
          <span  *ngIf="!showLoader"> Post </span>
          <mat-spinner *ngIf="showLoader"></mat-spinner>
        </button>
      </div>
    </div>
  </form>
</li>